import React, { useContext, useState } from "react";
import * as FaIcons from "react-icons/fa";
import moment from "moment";
import llacFav from "../../img/LLAC-favicon.ico";
import { Helmet } from "react-helmet-async";
import AddUserPermissionModal from "./AddUserPermissionModal";
import UpdateUserPermissionModal from "./UpdateUserPermissionModal";

import SearchForm from "../registrationAdmin/SearchForm";

import UserContext from "../../context/users/userContext";

const headers = [
  { name: "name", display: "Name" },
  { name: "status", display: "Status" },
  { name: "charterAssignments", display: "Charter Assignments" },
  { name: "action", display: "Update" },
];

const RegistrationFormRow = ({ info }) => {
  const { _id, name, userStatus, charterAssignments, allCharterAccess } = info;
  const userContext = useContext(UserContext);
  const { setFormModal, getUser } = userContext;

  return (
    <tr>
      <td>{name}</td>
      <td>{userStatus}</td>
      <td className="form-userperm">
        {allCharterAccess ? (
          <p>All Charters</p>
        ) : charterAssignments.length > 0 ? (
          <select name="" id="">
            {charterAssignments.map((item) => {
              return <option value="">{item.name}</option>;
            })}
          </select>
        ) : (
          <p>No Charter Assignments</p>
        )}
      </td>
      <td>
        <div
          className="btn btn-llac-dark-green"
          onClick={() => {
            setFormModal("updateUserPermissionModal", true);
            getUser(_id);
          }}
        >
          Update Permissions
        </div>
      </td>
    </tr>
  );
};

const TableHeaderItem = ({ name, display }) => {
  const userContext = useContext(UserContext);
  const { permissionsSortOptions, onPermissionTableFilter } = userContext;

  return (
    <th onClick={() => onPermissionTableFilter(name)}>
      <div className="wrap">
        <span>{display}</span>
        <div className="filter">
          <FaIcons.FaSortUp
            style={{
              color: permissionsSortOptions[name].asc ? "#343434" : "white",
            }}
          />
          <FaIcons.FaSortDown
            style={{
              color: permissionsSortOptions[name].desc ? "#343434" : "white",
            }}
          />
        </div>
      </div>
    </th>
  );
};

const PermissionsTable = ({ items }) => {
  const userContext = useContext(UserContext);
  const {
    searchFilter,
    clearSearchFilter,
    formModal,
    setFormModal,
    filteredUsers,
  } = userContext;
  const { addUserPermissionModal, updateUserPermissionModal } = formModal;
  return (
    <div className="app-permissions-component">
    <Helmet>
        <meta charSet="utf-8" />
        <title>User Permissions</title>
         <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      {addUserPermissionModal && <AddUserPermissionModal />}
      {updateUserPermissionModal && <UpdateUserPermissionModal />}
      <h2 className="text-center top-title">User Permissions</h2>
      <div className="add-btn-container">
        <div
          className="btn btn-llac-dark-green"
          onClick={() => setFormModal("addUserPermissionModal", true)}
        >
          Add New User <FaIcons.FaPlus className="plus-icon" />
        </div>
      </div>
      <SearchForm
        placeholderText="Search For Users"
        searchFilter={searchFilter}
        clearSearchFilter={clearSearchFilter}
      />
      <table id="app-permissions-table">
        <tr>
          {headers.map((header) => {
            return (
              <TableHeaderItem name={header.name} display={header.display} />
            );
          })}
        </tr>
        {filteredUsers && filteredUsers.length > 0
          ? filteredUsers.map((item) => {
              return (
                <RegistrationFormRow
                  info={item}
                />
              );
            })
          : items.map((item) => {
              return (
                <RegistrationFormRow
                  info={item}
                />
              );
            })}
      </table>
    </div>
  );
};

export default PermissionsTable;
